import { render, staticRenderFns } from "./PzUnnaxFaceIdIframe.vue?vue&type=template&id=72e24cb5&scoped=true&"
import script from "./PzUnnaxFaceIdIframe.vue?vue&type=script&lang=js&"
export * from "./PzUnnaxFaceIdIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e24cb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72e24cb5')) {
      api.createRecord('72e24cb5', component.options)
    } else {
      api.reload('72e24cb5', component.options)
    }
    module.hot.accept("./PzUnnaxFaceIdIframe.vue?vue&type=template&id=72e24cb5&scoped=true&", function () {
      api.rerender('72e24cb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/Fields/OpenBanking/PzUnnaxFaceIdIframe.vue"
export default component.exports